/*
  KP: behaviour for the "Case filters" section (sections/kp-case-filters.liquid).

  Choosing a model or case type does NOT reload the page or re-filter the collection.
  Each product tile is switched to the chosen model's own variant: its photo, its price,
  its link and its quick-add variant. The variant details come from one small Storefront
  API request per batch of tiles. Tiles added later (infinite scroll, sorting) are
  switched as well.

  Prices (13 Oct 2026, Sana: "the pricing should say from and then the cheapest price"):
  with only a model chosen, each tile says "from" and the cheapest price that model comes
  in (Tough, Snap or MagSafe Tough); the photo and link stay on the Tough case as before.
  With a case type chosen as well, the tile shows that exact price.

  The model list comes from window.kpCaseModels, which the section fills from
  snippets/kp-case-models.liquid.

  Model pages (13 Oct 2026): on a collection made for one phone model (template
  collection.phone-model, see PAGE_MODEL below) the dropdown starts on that model and
  choosing another model opens that model's page.
*/
(function () {
  var MP = 'filter.v.option.model';
  var CP = 'filter.v.option.case type';
  var STORE = 'kpCaseChoice';
  var TYPES = { T: 'Tough Case', S: 'Snap Case', M: 'Magsafe Tough Case' };
  var LABELS = { T: 'Tough Case', S: 'Snap Case', M: 'MagSafe Tough Case' };
  var GROUPS = [['iPhone', 'iPhone'], ['Galaxy', 'Samsung'], ['Pixel', 'Google Pixel'], ['Xiaomi', 'Xiaomi'], ['Oneplus', 'OnePlus'], [null, 'Other']];
  var API = '/api/2025-07/graphql.json';
  // Up to three variants per product: a, b and d are the model in up to three case types
  // (with a case type chosen, all three ask for the same one).
  var QUERY = [
    'query ($ids: [ID!]!, $a: [SelectedOptionInput!]!, $b: [SelectedOptionInput!]!, $d: [SelectedOptionInput!]!, $c: CountryCode) @inContext(country: $c) {',
    '  nodes(ids: $ids) {',
    '    ... on Product {',
    '      id',
    '      a: variantBySelectedOptions(selectedOptions: $a) { ...V }',
    '      b: variantBySelectedOptions(selectedOptions: $b) { ...V }',
    '      d: variantBySelectedOptions(selectedOptions: $d) { ...V }',
    '    }',
    '  }',
    '}',
    'fragment V on ProductVariant {',
    '  id',
    '  price { amount }',
    '  compareAtPrice { amount }',
    '  image {',
    '    s: url(transform: { maxWidth: 400 })',
    '    m: url(transform: { maxWidth: 700 })',
    '    l: url(transform: { maxWidth: 1100 })',
    '  }',
    '}'
  ].join('\n');
  var BATCH = 24;
  var MONEY_TOKEN = /\{\{\s*(\w+)\s*\}\}/;

  function withSeparators(value, decimals, thousands, decimal) {
    var parts = value.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.join(decimal);
  }

  // Prices in the store's own money format (the theme exposes it as theme.moneyFormat).
  function money(amount) {
    var format = window.theme && window.theme.moneyFormat;
    var value = parseFloat(amount);

    if (!format || isNaN(value) || !MONEY_TOKEN.test(format)) return '';

    return format.replace(MONEY_TOKEN, function (match, type) {
      switch (type) {
        case 'amount_no_decimals':
          return withSeparators(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return withSeparators(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withSeparators(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return withSeparators(value, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator':
          return withSeparators(value, 0, ' ', ',');
        case 'amount_with_space_separator':
          return withSeparators(value, 2, ' ', ',');
        default:
          return withSeparators(value, 2, ',', '.');
      }
    });
  }

  function codeOf(value) {
    for (var key in TYPES) {
      if (TYPES[key] === value) return key;
    }
    return '';
  }

  function groupOf(name) {
    for (var i = 0; i < GROUPS.length; i++) {
      if (GROUPS[i][0] === null || name.indexOf(GROUPS[i][0]) > -1) return GROUPS[i][1];
    }
    return '';
  }

  function readUrl() {
    var params = new URLSearchParams(window.location.search);
    return { model: params.get(MP) || '', kase: params.get(CP) || '' };
  }

  function readStore() {
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(STORE) || 'null');
      if (saved && typeof saved.model === 'string' && typeof saved.kase === 'string') return saved;
    } catch (e) {}
    return null;
  }

  // "t": when it was chosen, so assets/kp-variant-match.js can tell whether this choice or
  // the phone in the cart is newer.
  function writeStore(model, kase) {
    try {
      window.sessionStorage.setItem(STORE, JSON.stringify({ model: model, kase: kase, t: Date.now() }));
    } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent('kp:model-chosen'));
    } catch (e) {}
  }

  function init(root) {
    if (!root || root.kpReady) return;

    var DATA = window.kpCaseModels || [];
    var modelSelect = root.querySelector('[data-kp-model]');
    var caseSelect = root.querySelector('[data-kp-case]');
    var openButton = root.querySelector('[data-kp-open]');
    var currentLabel = root.querySelector('[data-kp-current]');
    var panel = root.querySelector('[data-kp-panel]');
    var search = root.querySelector('[data-kp-search]');
    var listBox = root.querySelector('[data-kp-list]');
    var wrapper = root.closest ? root.closest('.shopify-section') : null;

    if (!modelSelect || !caseSelect || !DATA.length) return;
    root.kpReady = true;

    var models = [];
    var byName = {};

    DATA.forEach(function (row) {
      row[2].split(',').forEach(function (part) {
        var item = { name: row[1] + part, types: row[0] };
        models.push(item);
        byName[item.name] = item;
      });
    });

    // A model page ("iPhone 17 Pro Max Phone Cases"): the collection only holds that
    // model's cases, the section sets window.kpPageModel to its model, and choosing
    // another model in the dropdown goes to that model's own page (or back to all phone
    // cases for "All models"). The page addresses follow the same rule as the collections:
    // the model name in lower case, + as -plus, other gaps as -, then -phone-cases.
    var PAGE_MODEL = window.kpPageModel && byName[window.kpPageModel] ? window.kpPageModel : '';

    function modelPage(model) {
      if (!model) return '/collections/phone-cases';
      return '/collections/' + model.toLowerCase().replace(/\+/g, '-plus').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') + '-phone-cases';
    }

    var modelLabel = modelSelect.options[0].textContent;
    var caseLabel = caseSelect.options[0].textContent;
    var shown = { model: '', kase: '' };
    var visibleModels = [];
    var enhanced = !!(openButton && panel && search && listBox);
    var cache = {};
    var inFlight = {};

    function makeOption(value, text, selected) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = text;
      if (selected) option.selected = true;
      return option;
    }

    function render(curModel, curCase) {
      var curCode = codeOf(curCase);
      shown = { model: curModel, kase: curCase };

      // Model list: every model, or only those that come in the chosen case type.
      var list = models.filter(function (item) {
        return !curCode || item.types.indexOf(curCode) > -1 || item.name === curModel;
      });

      if (curModel && !byName[curModel]) list.unshift({ name: curModel, types: '' });
      visibleModels = list;

      modelSelect.innerHTML = '';
      modelSelect.appendChild(makeOption('', modelLabel, !curModel));

      GROUPS.forEach(function (group) {
        var optgroup = document.createElement('optgroup');
        optgroup.label = group[1];

        list.forEach(function (item) {
          if (groupOf(item.name) === group[1]) {
            optgroup.appendChild(makeOption(item.name, item.name, item.name === curModel));
          }
        });

        if (optgroup.children.length) modelSelect.appendChild(optgroup);
      });

      if (currentLabel) currentLabel.textContent = curModel || modelLabel;

      // Case type list: every type, or only those the chosen model comes in.
      var available = curModel && byName[curModel] ? byName[curModel].types : 'TSM';

      caseSelect.innerHTML = '';
      caseSelect.appendChild(makeOption('', caseLabel, !curCase));

      ['T', 'S', 'M'].forEach(function (key) {
        if (available.indexOf(key) > -1 || TYPES[key] === curCase) {
          caseSelect.appendChild(makeOption(TYPES[key], LABELS[key], TYPES[key] === curCase));
        }
      });

      // Thumbnail follows the chosen case type (Tough when none is chosen).
      root.querySelectorAll('[data-kp-thumb]').forEach(function (img) {
        img.hidden = img.getAttribute('data-kp-thumb') !== (curCode || 'T');
      });
    }

    function targetUrl(model, kase) {
      var next = new URL(window.location.href);
      var params = next.searchParams;

      params.delete(MP);
      params.delete(CP);
      if (model && model !== PAGE_MODEL) params.append(MP, model);
      if (kase) params.append(CP, kase);

      var query = params.toString();
      return next.pathname + (query ? '?' + query : '');
    }

    // ---- Switch the product tiles to the chosen model's variant, without a page load ----

    // "Model|Case Type", or "Model|*" when no case type is chosen (then the tile says
    // "from" and the model's cheapest price).
    function currentKey() {
      if (!shown.model) return '';
      return shown.model + '|' + (shown.kase || '*');
    }

    // The case types to ask for: the chosen one, or (none chosen) the model's types,
    // Tough first so the photo and link stay on the Tough case.
    function typesFor(key) {
      var parts = key.split('|');
      if (parts[1] !== '*') return [parts[1]];

      var types = byName[parts[0]] ? byName[parts[0]].types : 'T';
      var list = ['T', 'S', 'M'].filter(function (code) {
        return types.indexOf(code) > -1;
      }).map(function (code) {
        return TYPES[code];
      });

      return list.length ? list : [TYPES.T];
    }

    function getTiles() {
      return Array.prototype.slice.call(document.querySelectorAll('.product-item[data-id]'));
    }

    function tileLinks(tile) {
      return Array.prototype.slice.call(tile.querySelectorAll('a[href*="/products/"]'));
    }

    function tilePrices(tile) {
      return Array.prototype.slice.call(tile.querySelectorAll('.product-item__price-main'));
    }

    function remember(tile) {
      if (tile.kpOrig) return;

      var img = tile.querySelector('img.image__img');

      tile.kpOrig = {
        src: img ? img.getAttribute('src') : null,
        srcset: img ? img.getAttribute('srcset') : null,
        variant: tile.getAttribute('data-variant-id'),
        links: tileLinks(tile).map(function (link) {
          return [link, link.getAttribute('href')];
        }),
        prices: tilePrices(tile).map(function (el) {
          return [el, el.innerHTML];
        })
      };
    }

    function paint(tile, variant, key, from) {
      remember(tile);
      tile.kpKey = key;

      if (!variant) return;

      var number = variant.id.split('/').pop();
      var img = tile.querySelector('img.image__img');

      if (img && variant.image) {
        img.setAttribute('srcset', variant.image.s + ' 400w, ' + variant.image.m + ' 700w, ' + variant.image.l + ' 1100w');
        img.setAttribute('src', variant.image.m);
      }

      tileLinks(tile).forEach(function (link) {
        try {
          var url = new URL(link.getAttribute('href'), window.location.origin);
          url.searchParams.set('variant', number);
          link.setAttribute('href', url.pathname + url.search + url.hash);
        } catch (e) {}
      });

      if (tile.hasAttribute('data-variant-id')) tile.setAttribute('data-variant-id', number);

      var html = '';

      if (from) {
        // No case type chosen: "from" and the cheapest price this model comes in.
        var cheapest = money(from);
        if (cheapest) html = 'from <span>' + cheapest + '</span>';
      } else {
        var price = variant.price ? money(variant.price.amount) : '';

        if (price) {
          var compare = variant.compareAtPrice ? parseFloat(variant.compareAtPrice.amount) : 0;
          html = '<span>' + price + '</span>';

          if (compare > parseFloat(variant.price.amount)) {
            html = '<s class="t-subdued">' + money(compare) + '</s> <span class="sale">' + price + '</span>';
          }
        }
      }

      if (html) {
        tilePrices(tile).forEach(function (el) {
          el.innerHTML = html;
        });
      }
    }

    function restore(tile) {
      if (!tile.kpOrig || !tile.kpKey) return;

      var img = tile.querySelector('img.image__img');

      if (img) {
        if (tile.kpOrig.srcset !== null) img.setAttribute('srcset', tile.kpOrig.srcset);
        if (tile.kpOrig.src !== null) img.setAttribute('src', tile.kpOrig.src);
      }

      tile.kpOrig.links.forEach(function (pair) {
        if (pair[1] !== null) pair[0].setAttribute('href', pair[1]);
      });

      tile.kpOrig.prices.forEach(function (pair) {
        pair[0].innerHTML = pair[1];
      });

      if (tile.kpOrig.variant !== null) tile.setAttribute('data-variant-id', tile.kpOrig.variant);
      tile.kpKey = '';
    }

    function load(key, ids) {
      var model = key.split('|')[0];
      var kinds = typesFor(key);
      var any = key.split('|')[1] === '*';

      function opts(i) {
        return [
          { name: 'Model', value: model },
          { name: 'Case Type', value: kinds[i] || kinds[0] }
        ];
      }

      var body = {
        query: QUERY,
        variables: {
          ids: ids.map(function (id) {
            return 'gid://shopify/Product/' + id;
          }),
          a: opts(0),
          b: opts(1),
          d: opts(2),
          c: (window.Shopify && window.Shopify.country) || null
        }
      };

      ids.forEach(function (id) {
        inFlight[key + '|' + id] = true;
      });

      return fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (json) {
          var nodes = (json && json.data && json.data.nodes) || [];

          ids.forEach(function (id, index) {
            var node = nodes[index] || {};
            var found = [node.a, node.b, node.d].filter(Boolean);
            var from = null;

            if (any && found.length) {
              found.forEach(function (v) {
                var amount = v.price ? parseFloat(v.price.amount) : NaN;
                if (!isNaN(amount) && (from === null || amount < from)) from = amount;
              });
            }

            cache[key + '|' + id] = { variant: found[0] || null, from: from };
          });
        })
        .catch(function () {
          // Leave these tiles as they are rather than asking again in a loop.
          ids.forEach(function (id) {
            cache[key + '|' + id] = { variant: null, from: null };
          });
        })
        .then(function () {
          ids.forEach(function (id) {
            delete inFlight[key + '|' + id];
          });
          swapTiles();
        });
    }

    function swapTiles() {
      var key = currentKey();
      var tiles = getTiles();

      if (!key) {
        tiles.forEach(restore);
        return;
      }

      var missing = [];

      tiles.forEach(function (tile) {
        if (tile.kpKey === key) return;

        var id = tile.getAttribute('data-id');
        var hit = cache[key + '|' + id];

        if (hit) {
          paint(tile, hit.variant, key, hit.from);
        } else if (!inFlight[key + '|' + id] && missing.indexOf(id) < 0) {
          missing.push(id);
        }
      });

      for (var i = 0; i < missing.length; i += BATCH) {
        load(key, missing.slice(i, i + BATCH));
      }
    }

    function apply(model, kase) {
      following = false;
      render(model, kase);
      writeStore(model, kase);

      try {
        window.history.replaceState(window.history.state, '', targetUrl(model, kase));
      } catch (e) {}

      swapTiles();
    }

    function chooseModel(model) {
      var kase = shown.kase || '';

      if (model && byName[model] && kase && byName[model].types.indexOf(codeOf(kase)) < 0) kase = '';

      // On a model page, another model (or "All models") is another page.
      if (PAGE_MODEL && model !== PAGE_MODEL) {
        writeStore(model, kase);
        window.location.href = modelPage(model) + (kase ? '?' + encodeURIComponent(CP).replace(/%20/g, '+') + '=' + encodeURIComponent(kase).replace(/%20/g, '+') : '');
        return;
      }

      apply(model, kase);
    }

    function chooseCase(kase) {
      var model = shown.model || '';

      if (model && byName[model] && kase && byName[model].types.indexOf(codeOf(kase)) < 0) model = '';
      apply(model, kase);
    }

    modelSelect.addEventListener('change', function () {
      chooseModel(modelSelect.value);
    });

    caseSelect.addEventListener('change', function () {
      chooseCase(caseSelect.value);
    });

    // ---- Searchable model list ----

    var activeIndex = -1;

    function optionButtons() {
      return Array.prototype.slice.call(listBox.querySelectorAll('[data-kp-value]'));
    }

    function setActive(index) {
      var buttons = optionButtons();

      if (!buttons.length) {
        activeIndex = -1;
        return;
      }

      activeIndex = Math.max(0, Math.min(index, buttons.length - 1));

      buttons.forEach(function (button, i) {
        button.classList.toggle('is-active', i === activeIndex);
      });

      var active = buttons[activeIndex];
      var top = active.offsetTop;
      var bottom = top + active.offsetHeight;

      if (top < listBox.scrollTop) listBox.scrollTop = top - 8;
      else if (bottom > listBox.scrollTop + listBox.clientHeight) listBox.scrollTop = bottom - listBox.clientHeight + 8;
    }

    function addOption(value, text) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'kp-case-filters__option';
      button.setAttribute('role', 'option');
      button.setAttribute('data-kp-value', value);
      button.setAttribute('aria-selected', value === shown.model ? 'true' : 'false');
      button.textContent = text;
      listBox.appendChild(button);
    }

    function renderList(query) {
      var words = query.toLowerCase().split(/\s+/).filter(Boolean);
      var lastGroup = null;
      var count = 0;

      listBox.innerHTML = '';

      if (!words.length && shown.model) addOption('', 'All models');

      GROUPS.forEach(function (group) {
        visibleModels.forEach(function (item) {
          if (groupOf(item.name) !== group[1]) return;

          var haystack = (item.name + ' ' + group[1]).toLowerCase();
          var match = words.every(function (word) {
            return haystack.indexOf(word) > -1;
          });

          if (!match) return;

          if (lastGroup !== group[1]) {
            var heading = document.createElement('div');
            heading.className = 'kp-case-filters__group';
            heading.textContent = group[1];
            listBox.appendChild(heading);
            lastGroup = group[1];
          }

          addOption(item.name, item.name);
          count++;
        });
      });

      if (!count) {
        var empty = document.createElement('div');
        empty.className = 'kp-case-filters__empty';
        empty.textContent = 'No models found';
        listBox.appendChild(empty);
      }

      activeIndex = -1;
      if (words.length && count) setActive(0);
      listBox.scrollTop = 0;
    }

    function isOpen() {
      return enhanced && !panel.hidden;
    }

    function closePanel(returnFocus) {
      if (!isOpen()) return;

      panel.hidden = true;
      if (wrapper) wrapper.classList.remove('kp-case-filters-open');
      openButton.setAttribute('aria-expanded', 'false');
      if (returnFocus) openButton.focus();
    }

    function openPanel() {
      panel.hidden = false;
      if (wrapper) wrapper.classList.add('kp-case-filters-open');
      openButton.setAttribute('aria-expanded', 'true');
      search.value = '';
      renderList('');

      var selected = listBox.querySelector('[aria-selected="true"]');
      if (selected) listBox.scrollTop = Math.max(0, selected.offsetTop - 60);

      // Only jump to the search box where there is a real keyboard, so phones show the list first.
      if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) search.focus();
    }

    if (enhanced) {
      modelSelect.hidden = true;
      modelSelect.setAttribute('tabindex', '-1');
      openButton.hidden = false;

      openButton.addEventListener('click', function () {
        if (isOpen()) closePanel(false);
        else openPanel();
      });

      search.addEventListener('input', function () {
        renderList(search.value);
      });

      search.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setActive(activeIndex + 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          setActive(activeIndex - 1);
        } else if (event.key === 'Enter') {
          event.preventDefault();
          var buttons = optionButtons();
          var typed = search.value.trim().toLowerCase();
          var exact = buttons.filter(function (button) {
            return button.textContent.trim().toLowerCase() === typed;
          })[0];
          var pick = exact || buttons[activeIndex > -1 ? activeIndex : 0];
          if (pick) pick.click();
        }
      });

      listBox.addEventListener('click', function (event) {
        var button = event.target.closest ? event.target.closest('[data-kp-value]') : null;
        if (!button) return;

        closePanel(true);
        chooseModel(button.getAttribute('data-kp-value'));
      });

      root.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && isOpen()) {
          event.stopPropagation();
          closePanel(true);
        }
      });

      document.addEventListener('pointerdown', function (event) {
        if (!isOpen()) return;
        if (panel.contains(event.target) || openButton.contains(event.target)) return;
        closePanel(false);
      });
    }

    // ---- Start: the address wins, then the choice made earlier in this visit ----

    var start = readUrl();

    if (!start.model && !start.kase) {
      var saved = readStore();

      if (saved && (saved.model || saved.kase) && (!saved.model || byName[saved.model])) {
        if (saved.model && saved.kase && byName[saved.model].types.indexOf(codeOf(saved.kase)) < 0) saved.kase = '';
        start = saved;
      }
    }

    // A case-type collection (Tough Case, Snap Case, MagSafe) starts on its own case type.
    var PAGE_CASE = { 'tough-case': 'Tough Case', 'tough-case-1': 'Tough Case', 'snap-case': 'Snap Case', 'tough-magsafe-case': 'Magsafe Tough Case' };
    var pageCase = PAGE_CASE[(window.location.pathname.split('/collections/')[1] || '').split('/')[0]];

    // A model page always starts on its own model (keeping a case type chosen earlier).
    if (PAGE_MODEL) {
      start = { model: PAGE_MODEL, kase: readUrl().kase || (start.model === PAGE_MODEL ? start.kase || '' : '') };
      if (start.kase && byName[PAGE_MODEL].types.indexOf(codeOf(start.kase)) < 0) start.kase = '';
    }

    if (pageCase && !readUrl().kase) {
      start = { model: start.model, kase: pageCase };
      if (start.model && byName[start.model] && byName[start.model].types.indexOf(codeOf(pageCase)) < 0) start.model = '';
    }

    // Variant match (assets/kp-variant-match.js): with nothing chosen on this page or
    // earlier in the visit, start on the phone in the cart. This is not saved as a
    // choice; it follows the cart until the shopper picks something here.
    var matcher = window.kpVariantMatch;
    var following = !start.model && !start.kase && !readStore() && !!matcher;

    function follow(model) {
      if (!following || !model || !byName[model] || model === shown.model) return;
      render(model, '');
      swapTiles();
    }

    if (start.model || start.kase) apply(start.model, start.kase);
    else render('', '');

    if (following) {
      follow(matcher.get());
      matcher.ready.then(function () {
        follow(matcher.get());
      });
      document.addEventListener('kp:model', function (event) {
        follow(event.detail && event.detail.model);
      });
    }

    // The theme's own filters rewrite the address; put the chosen model and case type back.
    function keepUrl() {
      if (following || (!shown.model && !shown.kase)) return;

      var params = new URLSearchParams(window.location.search);
      var wantModel = shown.model === PAGE_MODEL ? '' : shown.model;
      if ((params.get(MP) || '') === wantModel && (params.get(CP) || '') === shown.kase) return;

      try {
        window.history.replaceState(window.history.state, '', targetUrl(shown.model, shown.kase));
      } catch (e) {}
    }

    // New tiles (infinite scroll, sorting, the theme's own filters) get the chosen model too.
    if (window.MutationObserver) {
      var timer = null;

      new MutationObserver(function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          swapTiles();
          keepUrl();
        }, 60);
      }).observe(document.body, { childList: true, subtree: true });
    }

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) swapTiles();
    });
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('.kp-case-filters')).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // Theme editor: start again when the section is re-rendered.
  document.addEventListener('shopify:section:load', initAll);
})();
